import classNames from 'classnames'

import {
  MarkerEdgeIcon,
  MarkerPlaceIcon, // 식당
} from '@local/assets/icons/marker-cleanup'

import Image from '@web/components/Image'
import photoInfra from '@web/libs/media/photoInfra'

import styles from './ThumbnailMarker.module.scss'

export interface ThumbnailMarkerProps {
  thumbnailUrl?: string | null
  isSelected?: boolean
  typeSmall?: boolean
  name?: string
}

// 사진 마커
export default function ThumbnailMarker({
  thumbnailUrl,
  name,
  isSelected = false,
  typeSmall = false,
}: ThumbnailMarkerProps) {
  return (
    <div className={classNames(styles.thumb_marker, { [styles.selected]: isSelected, [styles.type_small]: typeSmall })}>
      <div className={styles.marker_inner}>
        <div className={styles.marker_area}>
          <div className={styles.thumb_area}>
            <div className={styles.thumb_inner}>
              {thumbnailUrl ? (
                <Image
                  src={thumbnailUrl}
                  width={36}
                  height={36}
                  alt=""
                  className={styles.thumb}
                  thumbnailType={photoInfra.type.f220_220_70_sharpen}
                  isSSR={true}
                />
              ) : (
                <MarkerPlaceIcon className={styles.icon_default} aria-hidden="true" />
              )}
            </div>
          </div>
          <span className={styles.icon_edge_wrapper}>
            <MarkerEdgeIcon className={styles.icon_edge} />
            <MarkerEdgeIcon className={styles.icon_edge_inner} />
          </span>
        </div>
        <div className={styles.info_area}>
          <div className={styles.tit_area}>
            <span className={styles.name}>{name}</span>
          </div>
        </div>
        {isSelected && <span className="place_blind">선택됨</span>}
      </div>
    </div>
  )
}
